import { apiFetch } from './client'

export type ControlPlaneChannel = 'telegram' | 'web' | 'cursor-cli' | 'codex-desktop' | 'manual'
export type ControlPlaneStatus =
  | 'running'
  | 'idle'
  | 'waiting_permission'
  | 'blocked'
  | 'aborted'
  | 'error'
  | 'stale'
  | 'closed'
export type ControlPlaneRunState =
  | 'none'
  | 'running'
  | 'cancelling'
  | 'cancelled'
  | 'completed'
  | 'failed'
  | 'timed_out'
  | 'blocked'

export interface ControlPlaneRegistryListDto {
  updatedAt: string
  records: ControlPlaneRegistryRecordDto[]
  filters: {
    channels: ControlPlaneChannel[]
    statuses: ControlPlaneStatus[]
    projects: Array<{ id: string; title: string }>
    agents: Array<{ agentId: string; role: string }>
  }
}

export interface ControlPlaneRegistryRecordDto {
  id: string
  agentId: string
  channel: ControlPlaneChannel
  role: string
  engine: string
  model: string
  mode: string
  project: {
    id: string
    cwd: string
    title?: string
    vaultRoot?: string
  }
  sprint: {
    id: string
    path: string
    status?: string
    goal?: string
  } | null
  status: ControlPlaneStatus
  currentTask: {
    title: string
    source: 'user_message' | 'roadmap' | 'handoff' | 'web_chat' | 'manual' | 'unknown'
    startedAt?: string
    summary?: string
    sourceRef?: string
  } | null
  claimedFiles: Array<{
    path: string
    access: 'read' | 'write' | 'planned'
    source: 'engine_edit_log' | 'handoff' | 'roadmap' | 'manual'
  }>
  lastCheckpoint: {
    at: string | null
    chatPath?: string
    roadmapPath?: string
    summary?: string
    commit?: string
  } | null
  lastSeen: string
  lastActivityAt: string | null
  runState: {
    state: ControlPlaneRunState
    runId?: string
    startedAt?: string
    updatedAt?: string
    cancellable: boolean
    cancelEndpoint?: string
    permission?: {
      id: string
      action: string
      path?: string
      risk?: string
    }
  }
  handoff?: {
    id: string
    state:
      | 'requested'
      | 'accepted'
      | 'rejected'
      | 'in_progress'
      | 'result_submitted'
      | 'result_accepted'
      | 'needs_rework'
      | 'closed'
    sourceRef: string
  } | null
  source: {
    runtime: string[]
    vault: string[]
    derived: string[]
  }
}

export function fetchControlPlaneRegistry(): Promise<ControlPlaneRegistryListDto> {
  return apiFetch<ControlPlaneRegistryListDto>('/api/control-plane/registry')
}
